import { Outlet } from '@tanstack/react-router';

export function TailoredSupplyPage() {
  return <Outlet />;
}
